/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment, memo } from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { FieldArray } from 'formik';
import { Divider, Icon } from 'semantic-ui-react';

import { plusButton, minus, sectionDivStyles } from '../../styles';
import { PlusIcon } from '../../../../../ui/icons';
import { useEffect } from 'react';
import LienSale from './Components/LienSale';
import PriorItem from './Components/PriorItem';

const TaxFormHeader = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
  margin: 52px auto 4% auto;
`;

const AddToSection = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #ff5252;
  cursor: pointer;
  margin-top: 3%;
`;

const PriorItems = ({ sectionOpen, setSectionOpen, taxes, setFieldValue, thruDate }) => {
  useEffect(() => {}, []);

  return (
    <div css={sectionDivStyles} id="Prior Items">
      {sectionOpen === 'Prior Items' ? (
        <Fragment>
          <div
            css={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div css={{ fontSize: 20 }}>Prior Items</div>
            <button
              type="button"
              css={plusButton}
              onClick={
                () => setSectionOpen('') // props.setState({ sectionOpen: !sectionOpen })
              }
            >
              {sectionOpen === 'Prior Items' ? <span css={minus} /> : <PlusIcon />}
            </button>
          </div>
          <TaxFormHeader>Prior Items</TaxFormHeader>
          <FieldArray name="taxes.priorItems">
            {arrayHelpers => (
              <Fragment>
                {taxes.priorItems.map((val, index) => (
                  <PriorItem
                    taxes={taxes}
                    setFieldValue={setFieldValue}
                    key={index}
                    priorItemIndex={index}
                    remove={arrayHelpers.remove}
                    thruDate={thruDate}
                  />
                ))}
                <Divider section />
                <AddToSection
                  onClick={() =>
                    arrayHelpers.push({
                      year: null,
                      unit: null,
                      backTaxes: [],
                      bidTaxes: [],
                      additionalFees: [],
                    })
                  }
                >
                  <Icon name="plus" /> Add Prior Item
                </AddToSection>
              </Fragment>
            )}
          </FieldArray>
          <TaxFormHeader>Lien Sales</TaxFormHeader>
          <FieldArray name="taxes.lienSale">
            {arrayHelpers => (
              <Fragment>
                {taxes.lienSale.map((val, index) => (
                  <LienSale
                    taxes={taxes}
                    setFieldValue={setFieldValue}
                    key={index}
                    index={index}
                    remove={arrayHelpers.remove}
                  />
                ))}
                <Divider section />
                <AddToSection onClick={() => arrayHelpers.push({})}>
                  <Icon name="plus" />
                  Add Lien Sale
                </AddToSection>
              </Fragment>
            )}
          </FieldArray>
        </Fragment>
      ) : (
        <div
          onClick={() => setSectionOpen('Prior Items')}
          css={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <h2>Prior Items</h2>
          <span css={plusButton}>
            <PlusIcon />
          </span>
        </div>
      )}
    </div>
  );
};

export default memo(PriorItems);
